import HttpClient from './httpClient';
import AuthUtils from '../../utils/auth.utils';

class Api {
  constructor(private readonly client: HttpClient = new HttpClient()) {}

  addAuthorizationHeader = (token: string) =>
    this.client.setHeader('Authorization', `Bearer ${token}`);

  getUser = async (email?: string) =>
    email
      ? this.client.get<ProfileResponse>(`/auth/user?email=${encodeURIComponent(email)}`)
      : this.client.get<ProfileResponse>('/auth/user');

  getUserAddresses = async (data: unknown) => {
    let url = '/address';

    if (Object.keys(data as Object).length > 0) {
      url = `${url}?${new URLSearchParams(data as URLSearchParams).toString()}`;
    }

    return this.client.get<AddressResponse>(url);
  };

  updateAddressForUser = async (data: Address) => this.client.post(`/address`, data);

  getCart = (cartId: string | undefined) => this.client.get<CartResponse>(`/carts/${cartId}`);

  getInstallments = (storeId: string, amount: string) =>
    this.client.get<InstallmentResponse>(
      `/payments/installments?storeId=${storeId}&amount=${amount}`
    );

  login = (body: LoginRequestBody) => this.client.post<LoginResponse>('/auth/login', body);

  refresh = () => {
    const refreshToken = AuthUtils.getRefreshToken();
    return this.client.post<LoginResponse>(
      '/auth/refresh',
      {},
      {
        headers: {
          Authorization: `Bearer ${refreshToken}`,
        },
      }
    );
  };

  logout = (body: unknown) => this.client.post('/auth/logout', body);

  createCart = (body: unknown) => this.client.post<CreateCartResponse>('/carts', body);

  createOrder = (body: CreateOrderRequestBody) =>
    this.client.post<CreateOrderResponse>('/orders', body);

  shouldShowOneTapSurvey = (body: ShowSurveyRequestData) =>
    this.client.get<ShowSurveyResponse>(
      `/orders/show-survey?external_cart_id=${body.externalCartId}`
    );

  sendCES = (body: CESRequestBody) => this.client.post('/ces', body);

  updateUser = (body: UpdateUserRequestBody) => this.client.patch('/users', body);

  log = (log: string, context?: Record<string, unknown>) =>
    this.client.post('/logger', { log, context });
}

export default Api;
